import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getContact = createSelector(property('contact'), identity);
export const isLoaded = createSelector(getContact, property('isLoaded'));
export const getError = createSelector(getContact, property('error'));



// WEBPACK FOOTER //
// ./src/modules/ContactDetail/selectors/index.js